export const PHONE_EXACTLY_TEN_MSG = "Phone number must be exactly 10 digits.";

/** Strip non-digits and cap length (default 10). */
export function digitsOnlyPhone(value, maxLen = 10) {
  return String(value ?? "").replace(/\D/g, "").slice(0, maxLen);
}

/** National 10-digit storage only — strips +1 / +91 prefixes, never stores country codes. */
export function nationalPhoneForStorage(phone) {
  const d = String(phone ?? "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 11 && d[0] === "1") return d.slice(1);
  if (d.length === 12 && d.startsWith("91")) return d.slice(2);
  if (d.length > 10) return d.slice(-10);
  return d;
}

/**
 * National 10-digit phone validation.
 * @param {string} number
 * @param {{ allowEmpty?: boolean }} opts
 */
export function validateTenDigitMobile(number, { allowEmpty = true } = {}) {
  const digits = digitsOnlyPhone(number, 10);
  if (!digits) {
    return allowEmpty ? "" : "Mobile is Required";
  }
  if (!/^\d{10}$/.test(digits)) {
    return PHONE_EXACTLY_TEN_MSG;
  }
  return "";
}
